import { render, staticRenderFns } from "./ManageProjectTemplates.vue?vue&type=template&id=3ed133b0&"
import script from "./ManageProjectTemplates.vue?vue&type=script&lang=js&"
export * from "./ManageProjectTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports